import PropTypes from 'prop-types';
import styled from 'styled-components';

import type { CommonProps, TypographyProps } from './constants';
import { COMMON, TYPOGRAPHY } from './constants';
import theme from './theme';

type Props = CommonProps & TypographyProps & { as?: string | React.ComponentType<any> | undefined };

const Text = styled.span<Props>`
  ${TYPOGRAPHY}
  ${COMMON}
`;

Text.defaultProps = {
  theme,
};

Text.propTypes = {
  ...TYPOGRAPHY.propTypes,
  ...COMMON.propTypes,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

Text.displayName = 'Text';

export { Text };
